import { WEB_PREFIX } from 'constants/common';

export const ACTIVITY_VIEW = 'activity-view';

export const TEST_ID_ACTIVITY_VIEW_START = `${WEB_PREFIX}${ACTIVITY_VIEW}`;

export const getActivityTestId = (activityTestId: string, ending: string): string => `${activityTestId}_${ending}`;
